module.exports = __webpack_public_path__ + "img/seller5.02311b64.jpg";